import { createContext, useState } from "react";
import { damagedPlacesValues } from "../data/constants";

export const onlineRequestContextDefaultValue = {
  PatternType: "3",
  DamagedPlace_Jsn: damagedPlacesValues,
  Pattern: "[]",
  DeviceStatus_EId: 2
};
export const OnlineRequestContext = createContext();
export const OnlineRequestProvider = ({ children }) => {
  const [state, setState] = useState(onlineRequestContextDefaultValue);
  const [usedState, setUsedState] = useState(null);
  return (
    <OnlineRequestContext.Provider
      value={{ state, setState, usedState, setUsedState }}
    >
      {children}
    </OnlineRequestContext.Provider>
  );
};
